import { render, staticRenderFns } from "./SchoolSwitcher.vue?vue&type=template&id=ecd8a9f4&scoped=true&"
import script from "./SchoolSwitcher.vue?vue&type=script&lang=js&"
export * from "./SchoolSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSwitcher.vue?vue&type=style&index=0&id=ecd8a9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd8a9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu})
